<template>
    <div>
        <f-api ref="api"/>
        <v-progress indeterminate v-if="isLoading" class="mb-3"/>
        <div v-if="availableCalendars !== null && availableCalendars.length > 0" class="text-center small mt-3">
            <div class="mb-2">Wählen einen Kalender:</div>
            <div v-for="cal in availableCalendars" v-bind:key="cal.id">
                <v-btn color="primary" block class="mb-2" @click="selectCalendar(cal.id)">{{ cal.summary }}</v-btn>
            </div>                
        </div>
    </div>
</template>
<script>
export default {
    name: 'kc-calendar-select',
    emits: ['update:modelValue'],
    data() {
        return {   
            error: null,
            isLoading: true,
            availableCalendars: []         
        }
    },
    props: {
        modelValue: null
    },
    computed: {
        calendarId: {
            get() {
                const vm = this;
                return vm.modelValue;
            },
            set(v) {
                const vm = this;
                if (v === null) {
                    vm.loadAvailableCalendars();
                }
                vm.$emit('update:modelValue', v);
            }
        }
    },
    mounted() {
        const vm = this;
        vm.loadAvailableCalendars();
    },
    methods: {
        async loadAvailableCalendars() {
            const vm = this;
            vm.error = null;
            vm.availableCalendars = [];
            vm.isLoading = true;
            try {
                let result = await vm.$refs.api.getAsync('calendar/list');
                vm.availableCalendars = result;
                
            } catch (err) {
                vm.error = err;
            } finally {
                vm.isLoading = false;
            }
        },
        selectCalendar(id) {
            const vm = this;
            vm.calendarId = id;
        }           
    }
}
</script>
<style lang="sass" scoped>
</style>